// removed by extract-text-webpack-plugin
module.exports = {"container":"container___330gR","icon":"icon___2Zx1e","renderImage":"renderImage___3wntq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Carousel.module.css
// module id = 411
// module chunks = 0